import { HashLocationStrategy, PlatformLocation } from '@angular/common';
import { inject, Injectable } from '@angular/core';

/**
 * Hash routing that keeps the document's own path in every URL it writes. Angular's
 * HashLocationStrategy hands history a bare `#/well/1`, which the browser resolves against
 * `<base href>` rather than the document — so under the Electron panel's `./` base, loaded from
 * `file://…/dist/ken-live/index.html`, the address became `file://…/dist/ken-live/#/well/1` and a
 * reload asked for the directory instead of index.html. Prefixing the current pathname keeps
 * `index.html` in the address, so `location.reload()` reloads it.
 */
@Injectable()
export class FileHashLocationStrategy extends HashLocationStrategy {
  private readonly platformLocation = inject(PlatformLocation);

  override prepareExternalUrl(internal: string): string {
    const hash = super.prepareExternalUrl(internal);
    return hash && `${this.platformLocation.pathname}${hash}`;
  }
}
